import React from 'react';
import { SLAB_BOUNDS } from '../../../game/phaserFacility/facilityLayout';
import { TILE_SIZE } from './facilityCoords';
import { groundTiers, groundSeamOffsets } from './groundLayout';

const OUTER_COLOR = '#121614';
const INNER_COLOR = '#1c2220';
const SEAM_COLOR = '#2a3230';

/**
 * Two-tier industrial yard: dark outer apron + lighter inner pad with panel seams.
 */
export function GroundPlane() {
  const g = groundTiers(SLAB_BOUNDS, TILE_SIZE, 5, 1.5);
  const seams = groundSeamOffsets(g.inner.w, g.inner.d, 4);

  return (
    <group position={[g.centerX, 0, g.centerZ]}>
      <mesh position={[0, -0.02, 0]} rotation={[-Math.PI / 2, 0, 0]} receiveShadow>
        <planeGeometry args={[g.outer.w, g.outer.d]} />
        <meshStandardMaterial color={OUTER_COLOR} roughness={0.98} metalness={0} />
      </mesh>

      <mesh position={[0, -0.01, 0]} rotation={[-Math.PI / 2, 0, 0]} receiveShadow>
        <planeGeometry args={[g.inner.w, g.inner.d]} />
        <meshStandardMaterial color={INNER_COLOR} roughness={0.92} metalness={0.02} />
      </mesh>

      {seams.map((s, i) => (
        <mesh
          key={i}
          position={s.axis === 'x' ? [s.offset, -0.005, 0] : [0, -0.005, s.offset]}
          rotation={[-Math.PI / 2, 0, 0]}
        >
          <planeGeometry
            args={s.axis === 'x' ? [0.04, g.inner.d * 0.98] : [g.inner.w * 0.98, 0.04]}
          />
          <meshStandardMaterial color={SEAM_COLOR} roughness={1} metalness={0} />
        </mesh>
      ))}
    </group>
  );
}
